import { tv } from 'tailwind-variants'

import { h5 } from '@ui-kit/core/typography'

export const textSeparator = tv({
  slots: {
    line: 'absolute -z-10 w-full border-b border-ui-grey-50',
    container: 'relative flex w-full flex-col items-center justify-center',
    textContainer: 'flex w-full flex-row items-center justify-center',
    text: [h5(), 'max-w-[80%] px-2.5 text-center'],
  },
})
